import React, { useCallback, useEffect } from 'react'
import { moduleContext } from 'react-contextual'
import { useDispatch, useSelector } from 'react-redux'
import { invoiceApiEvents, invoiceApiSelectors } from 'modules/api/invoice'
import { useEffectOnce } from 'react-use'
import { reconApiEvents, reconApiSelectors } from 'modules/api/recon'

interface ActiveInvoicesProviderProps {
  customerId?: string
  accountId?: string
  context?: any
  children?: React.ReactNode
}

const ActiveInvoicesProvider = moduleContext()(({ context, children, ...props }: ActiveInvoicesProviderProps) => {
  const { customerId, accountId } = props
  const dispatch = useDispatch()

  const fetchInvoiceTypes = useCallback(() => dispatch(invoiceApiEvents.invoiceTypes_request()), [dispatch])

  useEffectOnce(() => {
    fetchInvoiceTypes()
  })

  useEffect(() => {
    // Both ids are path segments on CUSTOMER_OPEN_INVOICES, so a missing one would request
    // `/customers/undefined/invoices/undefined/open`.
    if (customerId && accountId) {
      dispatch(reconApiEvents.customerActiveInvoices_request({ customerId, accountId }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, accountId])

  const activeInvoicesStore = {
    fetchInvoiceTypes,
    invoiceTypes: useSelector(state => invoiceApiSelectors.getInvoiceTypes(state)),
    activeInvoices: useSelector(state =>
      customerId && accountId ? reconApiSelectors.getCustomerActiveInvoicesByAccount(state)(customerId, accountId) : [],
    ),
  }

  return <context.Provider value={activeInvoicesStore}>{children}</context.Provider>
})

export default ActiveInvoicesProvider
